import {FirebaseAnalytics} from '@capacitor-community/firebase-analytics';
import store from '@/store/index.js';
import {LANGUAGE_LABELS, LANGUAGE} from '@/constant/language';
import {PRODUCT_TAGS} from '@/constant/market.js';

/**
 * 設定使用者ID
 * @param {String} username 檔案在cdn的路徑
 */
export const setUserId = (username) => {
  if (!window.isApp) return;
  FirebaseAnalytics.setUserId({
    userId: username ? window.btoa(username) : null,
  });
};

/**
 * 設定使用者屬性
 * @param {String} key key
 * @param {String} value value
 */
export const setUserProperty = (key, value) => {
  if (!window.isApp) return;
  FirebaseAnalytics.setUserProperty({
    name: key,
    value,
  });
};

/**
 * setScreenName
 * @param {String} name name
 */
export const setScreenName = (name) => {
  if (!window.isApp) return;
  FirebaseAnalytics.setUserProperty({
    screenName: name,
  });
};

/**
 * setScreenName
 * @param {String} type type
 */
export const selectContent = (type, ...names) => {
  const locale = store.state.env.locale || LANGUAGE.ZH_TW;
  const lang = LANGUAGE_LABELS[locale] || LANGUAGE_LABELS[LANGUAGE.ZH_TW];
  if (!window.isApp) return;

  FirebaseAnalytics.logEvent({
    name: 'select_content',
    params: {
      lang,
      content_type: type, // 參考下方文件，不同事件有不同參數
      content_name: names[0], // 參考下方文件，不同事件有不同參數
      subcontent_name: names[1], // 參考下方文件，不同事件有不同參數
      subcontent2_name: names[2], // 參考下方文件，不同事件有不同參數
      // https://docs.google.com/presentation/d/1Ft1r0oIEcvQW61BPiKq87imYrMp8DTKEDjqUnOjnB-Q/edit#slide=id.g2f9159474ce_1_19
    },
  });
};

/**
 * getItemCategory
 * @param {String} locale locale
 * @return {String} itemCategory
 */
const getItemCategory = (locale) => {
  const mapping = {
    [LANGUAGE.ZH_TW]: '中文版',
    [LANGUAGE.EN_US]: '英文版',
    [LANGUAGE.JA_JP]: '日文版',
    [LANGUAGE.ZH_CN]: '簡體版',
  };
  return mapping[locale] || '其他版本';
};

/**
 * getItemBrand
 * @param {product} product product
 * @return {String} itemBrand
 */
const getItemBrand = (product) => {
  const tags = product.tags || [];
  const mapping = {
    [PRODUCT_TAGS.COURSE_PLAN]: '一般課程',
    [PRODUCT_TAGS.PHYSICAL]: '實體商品',
    [PRODUCT_TAGS.BUNDLE]: '組合方案',
    [PRODUCT_TAGS.LIVE_COURSE]: '直播課程',
    [PRODUCT_TAGS.WCP_2026]: '2026 世界冠軍系列',
    [PRODUCT_TAGS.VIP]: 'VIP方案',
    [PRODUCT_TAGS.LIVE_COURSE_UNIT_CARD]: '直播票卷',
    [PRODUCT_TAGS.VERIFICATION]: '模擬檢定',
    [PRODUCT_TAGS.KINI]: '棋院版',
    [PRODUCT_TAGS.TGC]: '圍棋學院',
    [PRODUCT_TAGS.KGP]: 'KGP',
    [PRODUCT_TAGS.COOPERATION]: '合作課程',
    [PRODUCT_TAGS.ITP]: '師資培訓',
    [PRODUCT_TAGS.SVC]: '序號',
    [PRODUCT_TAGS.MC_TYPE]: '教學課件',
  };
  const result = tags.map((tag) => mapping[tag] || '其他類別').filter(Boolean);
  return [...new Set(result)].join(','); // 去重並轉成字串
};

/**
 * productEvent
 * @param {event} event event
 * @param {product} product product
 */
export const productEvent = (event, product) => {
  if (!window.isApp) return;
  const locale = store.state.env.locale || LANGUAGE.ZH_TW;
  const itemBrand = getItemBrand(product);
  const itemCategory = getItemCategory(locale);

  const currency = 'TWD'; // 換成台幣
  const price = product.price[currency].sellPrice;

  FirebaseAnalytics.logEvent({
    name: event,
    params: {
      currency,
      value: price,
      items: [
        {
          item_id: product.id, // 產品ID，中英文產品一樣
          item_name: product.name, // 產品名稱，中英文產品一樣，統一使用中文產品名稱
          item_brand: itemBrand, // 產品類別，如:一般課程,組合方案，中英文產品一樣，統一使用中文產品名稱
          item_category: itemCategory, // 區分中文/英文產品，如:中文版, 英文版
          price, // 產品販售價格
          quantity: 1, // 產品數量
        },
      ],
    },
  });
};

export default {
  setUserId,
  setUserProperty,
  setScreenName,
  selectContent,
  productEvent,
};
